import Format from "../util/Format";
import DateTime from "../util/DateTime";
import GaauService from "./GaauService";

class CsvGaauService {

    Get(itens) {
        if (!itens) return [];
      return itens.map((elem) => {
        let data =  DateTime.FormatLocale(elem.date);
        let resultName = GaauService.ResultName(elem.result);
        let cap = Format.Number(elem.cap);
        let dap = Format.Number(elem.dap);
        return {
          Id: elem.sequence,
          Data: data,
          NomeComum: elem.commonName,
          NomeCientifico: elem.scientificName,
          Origem: elem.origin,
          Familia: elem.family,
          Situacao: elem.status,
          Altura: elem.heigth,
          ClasseAltura: elem.heigthClass,
          CAP: cap,
          DAP: dap,
          AlturaPrimeiraBifurcacao: elem.fisrtHeigth,
          Raio1: elem.radiusOne,
          Raio2: elem.radiusTwo,
          Raio3: elem.radiusThree,
          Raio4: elem.radiusFour,
          GalhosInterferindo: elem.branchesInterfering,
          GalhosSecosPodres: elem.branchesEchoes,
          ErvaPassarinho: elem.birdWeed,
          ArquiteturaCopa: elem.balancedCup,
          CabeamentoEscora: elem.anchorCabling,
          Cavidade: elem.cavity,
          FigueiraMataPau: elem.figTreeKillsWood,
          Cupim: elem.termite,
          FormigaCortadeira: elem.leafCuttingAnt,
          Coleobrocas: elem.snailDrills,
          Fungo: elem.fungus,
          DeficienciaNutricional: elem.nutritionalDeficiency,
          InclinacaoTronco: elem.trunkTilt,
          BrotacoesEpicormica: elem.epicormicShoots,
          AreaLivre: elem.freeArea,
          ColoSoterrado: elem.buriedLap,
          LevantamentoCalcada: elem.sidewalkSurvey,
          CirculacaoPedestres: elem.pedestrianCirculation,
          CirculacaoVeiculos: elem.circulationVehicles,
          Resultado: resultName,
          Latitude: elem.latitude,
          Longitude: elem.longitude,
          Carbono: elem.carbon,
          Observacao: elem.obs,
          Usuario: elem.userName,
          Unico: elem.id
        };
      });

    }

}

export default new CsvGaauService();